import { useEffect } from "react";
import { Avatar, AvatarGroupItem } from "@fluentui/react-components";
import { useFileIntoBlobUrl } from "../../files/hooks/useFileQueries";
//import { useUserPhotoBlobUrlQuery } from "../hooks/useUserQueries";

export default function UserAvatar({ user, url, ...avatarProps }) {
  const { blobUrl: photoBlobUrl } = useFileIntoBlobUrl(
    user?.public_photo_id,
    !url && !!user?.id && !!user?.public_photo_id,
  );

  useEffect(() => {
    // Only revoke photoBlobUrl (fetched by this component), not url (managed by parent)
    if (photoBlobUrl) {
      return () => {
        URL.revokeObjectURL(photoBlobUrl);
      };
    }
  }, [photoBlobUrl]);

  return (
    <Avatar
      {...avatarProps}
      name={`${user?.name || "User"}`}
      image={url || photoBlobUrl ? { src: url || photoBlobUrl } : undefined}
    />
  );
}

export function UserAvatarGroupItem({ user, url, ...avatarProps }) {
  const { blobUrl: photoBlobUrl } = useFileIntoBlobUrl(
    user?.public_photo_id,
    !url && !!user?.id && !!user?.public_photo_id,
  );

  useEffect(() => {
    // Only revoke photoBlobUrl (fetched by this component), not url (managed by parent)
    if (photoBlobUrl) {
      return () => {
        URL.revokeObjectURL(photoBlobUrl);
      };
    }
  }, [photoBlobUrl]);

  return (
    <AvatarGroupItem
      {...avatarProps}
      name={`${user?.name || "User"}`}
      image={url || photoBlobUrl ? { src: url || photoBlobUrl } : undefined}
    />
  );
}
